<template>
  <img
    v-if="name"
    :src="getAsset(name, variant)"
    :class="iconClasses"
    v-bind="nonClassAttrs"
  >
</template>

<script>
// Pre-import all icons using Vite's glob import
const iconModules = import.meta.glob('../../assets/icons/*.svg', { eager: true, query: '?url', import: 'default' });

const variantHexMap = {
  'mastery': '00dbfb',
  'white': 'ffffff',
  'content-secondary': '555555',
};

// Build a lookup map from icon name to URL
const iconMap = {};
Object.entries(iconModules).forEach(([path, url]) => {
  // Extract filename without extension: ../../assets/icons/foo.svg -> foo
  const filename = path.split('/').pop().replace('.svg', '');
  iconMap[filename] = url;
});

export default {
  name: 'Icon',
  inheritAttrs: false,
  props: {
    name: {
      type: String,
    },
    variant: {
      type: String,
      default: '',
    },
  },
  computed: {
    iconClasses() {
      const classes = [`icon-${this.name}`];
      // Preserve classes passed from parent components
      if (this.$attrs.class) {
        if (typeof this.$attrs.class === 'string') {
          classes.push(this.$attrs.class);
        } else if (Array.isArray(this.$attrs.class)) {
          classes.push(...this.$attrs.class);
        } else if (typeof this.$attrs.class === 'object') {
          Object.keys(this.$attrs.class).forEach(key => {
            if (this.$attrs.class[key]) {
              classes.push(key);
            }
          });
        }
      }
      return classes;
    },
    nonClassAttrs() {
      // Filter out class attribute since we handle it separately with iconClasses
      const { class: _, ...attrs } = this.$attrs;
      return attrs;
    },
  },
  methods: {
    getAsset(name, variant) {
      let iconName = name;
      if (variant) {
        const variantHex = variantHexMap[variant] || variant;
        iconName = `${name}-${variantHex}`;
      }
      const url = iconMap[iconName];
      if (!url) {
        console.error(`Icon not found: "${iconName}". Check that the SVG exists in src/assets/icons/.`);
      }
      return url || null;
    },
  },
};
</script>
